import { Typography } from "@mui/material";
import Link from "@mui/material/Link";
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  footer: {
    textAlign: "center",
    width: "100%",
    position: "fixed",
    left: 0,
    bottom: 0,
    backgroundColor: "white",
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <Typography variant="body2" align="center">
        <strong>Email Us</strong>:{" "}
        <Link color="inherit" href="mailto:sales@lptech.com" underline="hover">
          Sales
        </Link>{" "}
        <Link color="inherit" href="mailto:support@lptech.com" underline="hover">
          | Support
        </Link>{" "}
        - <strong>Skype</strong>: info@lptech.com
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © 2021 "}
        <Link color="inherit" href="http://www.lptech.com" underline="hover">
          LP Technologies, Inc.
        </Link>
        , 7330 W. 13th St. N, Wichita, KS 67212
      </Typography>
    </footer>
  );
};

export default Footer;
